import { render, staticRenderFns } from "./insureRuleUg.vue?vue&type=template&id=23b5fe24&scoped=true"
import script from "./insureRuleUg.vue?vue&type=script&lang=js"
export * from "./insureRuleUg.vue?vue&type=script&lang=js"
import style0 from "./insureRuleUg.vue?vue&type=style&index=0&id=23b5fe24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5fe24",
  null
  
)

export default component.exports